<footer class="modern-footer">
    <div class="footer-top">
        <div class="container">
            <div class="row">
                <!-- Section Logo et Description -->
                <div class="col-lg-4 col-md-6 mb-4">
                    <div class="footer-brand">
                        <div class="footer-logo">
                            <a routerLink="/" class="logo-link">
                                <img [src]="appSettingService.value.footer_logo" [alt]="appSettingService.value.name" class="logo-img">
                            </a>
                        </div>
                        <div class="footer-description">
                            <p>{{ appSettingService.value.short_description }}</p>
                        </div>
                        <div class="social-links">
                            <h5>Suivez-nous</h5>
                            <div class="social-icons">
                                <a [href]="appSettingService.value.youtube_url" title="Youtube" target="_blank" class="social-icon youtube">
                                    <i class="icofont-youtube-play"></i>
                                </a>
                                <a [href]="appSettingService.value.facebook_url" title="Facebook" target="_blank" class="social-icon facebook">
                                    <i class="icofont-facebook"></i>
                                </a>
                                <a [href]="appSettingService.value.instagram_url" title="Instagram" target="_blank" class="social-icon instagram">
                                    <i class="icofont-instagram"></i>
                                </a>
                                <a [href]="appSettingService.value.twiter_url" title="Twitter" target="_blank" class="social-icon twitter">
                                    <i class="icofont-twitter"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Section Raccourcis -->
                <div class="col-lg-2 col-md-6 mb-4">
                    <div class="footer-links">
                        <h4 class="footer-title">
                            <i class="icofont-navigation-menu"></i>
                            Raccourcis
                        </h4>
                        <ul class="footer-menu">
                            <li><a routerLink="/" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Accueil
                            </a></li>
                            <li><a routerLink="/about" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                À propos de la BSTP
                            </a></li>
                            <li><a routerLink="/blog" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Actualités
                            </a></li>
                            <li><a routerLink="/missions" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Missions
                            </a></li>
                            <li><a routerLink="/guides" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Guides d'utilisation
                            </a></li>
                            <li><a routerLink="/faq" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                FAQs
                            </a></li>
                        </ul>
                    </div>
                </div>

                <!-- Section Services -->
                <div class="col-lg-2 col-md-6 mb-4">
                    <div class="footer-links">
                        <h4 class="footer-title">
                            <i class="icofont-briefcase"></i>
                            Services
                        </h4>
                        <ul class="footer-menu">
                            <li><a routerLink="/create-account" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Créer un compte
                            </a></li>
                            <li><a routerLink="/login" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Se connecter
                            </a></li>
                            <li><a routerLink="/contact" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Nous contacter
                            </a></li>
                            <li><a routerLink="/partners" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Nos partenaires
                            </a></li>
                            <li><a routerLink="/bstp-team" class="footer-link">
                                <i class="icofont-simple-right"></i>
                                Notre équipe
                            </a></li>
                        </ul>
                    </div>
                </div>

                <!-- Section Contact -->
                <div class="col-lg-4 col-md-6 mb-4">
                    <div class="footer-contact">
                        <h4 class="footer-title">
                            <i class="icofont-location-pin"></i>
                            Contactez-nous
                        </h4>
                        
                        <div class="contact-info">
                            <div class="contact-item">
                                <div class="contact-icon">
                                    <i class="icofont-location-pin"></i>
                                </div>
                                <div class="contact-details">
                                    <h6>Adresse</h6>
                                    <p>{{ appSettingService.value.address }}</p>
                                </div>
                            </div>

                            <div class="contact-item">
                                <div class="contact-icon">
                                    <i class="icofont-ui-call"></i>
                                </div>
                                <div class="contact-details">
                                    <h6>Téléphone</h6>
                                    <p>
                                        <a href="tel:{{ appSettingService.value.phone_number1 }}">{{ appSettingService.value.phone_number1 }}</a>
                                    </p>
                                    <p>
                                        <a href="tel:{{ appSettingService.value.phone_number2 }}">{{ appSettingService.value.phone_number2 }}</a>
                                    </p>
                                </div>
                            </div>

                            <div class="contact-item">
                                <div class="contact-icon">
                                    <i class="icofont-ui-email"></i>
                                </div>
                                <div class="contact-details">
                                    <h6>Email</h6>
                                    <p>
                                        <a href="mailto:{{ appSettingService.value.email }}">{{ appSettingService.value.email }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Newsletter -->
                        <div class="newsletter-section">
                            <h5>
                                <i class="icofont-envelope"></i>
                                Newsletter
                            </h5>
                            <p>Restez informé de nos dernières actualités</p>
                            <form method="GET" action="https://kikk.us6.list-manage.com/subscribe" class="newsletter-form" target="_blank">
                                <input type="hidden" name="u" value="d08fe605a9149dc54a3c13f44">
                                <input type="hidden" name="id" value="96f67efdeb">
                                <div class="newsletter-input-group">
                                    <input type="email" required name="Email" id="email" placeholder="Votre adresse email" class="newsletter-input">
                                    <button type="submit" class="newsletter-btn">
                                        <i class="icofont-send-mail"></i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="copyright">
                        <p>&copy; {{ appSettingService.value.copyright }}</p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="footer-legal">
                        <ul class="legal-links">
                            <li>
                                <a routerLink="/terms-and-conditions" class="legal-link">
                                    <i class="icofont-file-text"></i>
                                    Termes & Conditions
                                </a>
                            </li>
                            <li>
                                <a routerLink="/privacy-policy" class="legal-link">
                                    <i class="icofont-shield"></i>
                                    Politique de Confidentialité
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Back to Top Button -->
    <div class="back-to-top" (click)="scrollToTop()">
        <i class="icofont-arrow-up"></i>
    </div>
</footer>